import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy WordPress clone page — permanently redirect to the canonical post.
export const Route = createFileRoute("/clone-of-how-do-clinics-ensure-donor-area-preservation-for-future-needs")({
  beforeLoad: () => {
    throw redirect({
      href: "/how-do-clinics-ensure-donor-area-preservation-for-future-needs/",
      statusCode: 301,
    });
  },
});
